module.exports = __webpack_public_path__ + "static/röver-office-mobile-627079338fda93508ab2216381f963a7.jpg";